import React from 'react';
import { MapContainer, TileLayer, CircleMarker, Tooltip } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
const PHOENIX_CITIES: {
  name: string;
  coords: [number, number];
}[] = [{
  name: 'Phoenix',
  coords: [33.4484, -112.074]
}, {
  name: 'Scottsdale',
  coords: [33.4942, -111.9261]
}, {
  name: 'Gilbert',
  coords: [33.3528, -111.789]
}, {
  name: 'Chandler',
  coords: [33.3062, -111.8413]
}, {
  name: 'Mesa',
  coords: [33.4152, -111.8315]
}, {
  name: 'Tempe',
  coords: [33.4255, -111.94]
}, {
  name: 'Queen Creek',
  coords: [33.2487, -111.6343]
}, {
  name: 'Glendale',
  coords: [33.5387, -112.186]
}, {
  name: 'Peoria',
  coords: [33.5806, -112.2374]
}, {
  name: 'Surprise',
  coords: [33.6292, -112.368]
}, {
  name: 'Goodyear',
  coords: [33.4355, -112.3576]
}, {
  name: 'Avondale',
  coords: [33.4356, -112.3496]
}, {
  name: 'Cave Creek',
  coords: [33.8333, -111.9508]
}, {
  name: 'Fountain Hills',
  coords: [33.6118, -111.7174]
}, {
  name: 'Paradise Valley',
  coords: [33.5311, -111.9426]
}, {
  name: 'Ahwatukee',
  coords: [33.3466, -112.0444]
}];
export function ServiceArea() {
  return <section id="service-area" className="bg-apex-light py-20 md:py-28" data-id="element-150">
      <div className="container mx-auto px-4 md:px-6" data-id="element-151">
        <div className="text-center md:text-left mb-12 md:mb-16" data-id="element-152">
          <span className="text-apex-green font-bold text-sm uppercase tracking-[0.2em] block mb-4" data-id="element-153">
            We Serve The Phoenix Metro
          </span>
          <h2 className="text-apex-charcoal font-extrabold text-3xl md:text-5xl tracking-tight" data-id="element-154">
            Phoenix, East Valley, And Beyond.
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-155">
          {/* Left: Real Leaflet Map */}
          <div className="rounded-md border border-gray-200 shadow-sm overflow-hidden aspect-square md:aspect-video lg:aspect-square relative bg-white" data-id="element-156">
            <MapContainer center={[33.55, -111.97]} zoom={9} scrollWheelZoom={false} className="w-full h-full" style={{
            background: '#F4F5F7'
          }} data-id="element-157">
              <TileLayer attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="https://carto.com/">CARTO</a>' url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png" data-id="element-158" />
              {PHOENIX_CITIES.map(city => <CircleMarker key={city.name} center={city.coords} radius={city.name === 'Phoenix' ? 10 : 7} pathOptions={{
              color: '#1A1F2B',
              weight: 2,
              fillColor: '#5CB85C',
              fillOpacity: 0.85
            }} data-id="element-159">
                  <Tooltip direction="top" offset={[0, -8]} opacity={1} permanent={city.name === 'Phoenix'} className="apex-map-tooltip" data-id="element-160">
                    <span className="text-xs font-bold text-apex-charcoal" data-id="element-161">
                      {city.name}
                    </span>
                  </Tooltip>
                </CircleMarker>)}
            </MapContainer>
          </div>

          {/* Right: City List */}
          <div data-id="element-162">
            <div className="grid grid-cols-2 gap-x-4 gap-y-4 mb-10" data-id="element-163">
              {PHOENIX_CITIES.map((city, index) => <div key={index} className="flex items-center gap-2" data-id="element-164">
                  <div className="w-1.5 h-1.5 rounded-full bg-apex-green shrink-0" data-id="element-165" />
                  <span className="text-apex-charcoal font-medium" data-id="element-166">
                    {city.name}
                  </span>
                </div>)}
            </div>

            <a href="#contact" className="inline-flex items-center justify-center bg-apex-green hover:bg-green-600 text-white px-8 py-4 rounded-md font-bold text-lg transition-all shadow-md hover:shadow-lg hover:-translate-y-0.5 min-h-[48px] w-full sm:w-auto" data-id="element-167">
              Check My Listing Address
            </a>
          </div>
        </div>
      </div>
    </section>;
}